import {useEffect, useState, useRef} from 'react';
import useScroll from './useScroll';

let silent : boolean;

export const setSilent = (value: boolean) => {
	silent = value;
};

/**
 * Calculates the scroll direction (up or down)
 * @param {number} updateThreshold - threshold for direction updates in pixels
 * @param {Boolean} ignoreOverscroll - ignore overscroll events (f.e. on Apple devices)
 * @returns {string} scroll direction (up or down)
 */
export const useScrollDirection = (updateThreshold: number = 15, ignoreOverscroll: boolean = false): string => {
	const [scrollDirection, setScrollDirection] = useState<string>(null);
	const lastDirection = useRef(null);
	const lastScrollY = useRef(0);
	const {onScroll, unBind} = useScroll();

	const updateScrollDirection = () => {
		if (
			silent
			|| (ignoreOverscroll && document.body.scrollHeight - updateThreshold <= window.scrollY + window.innerHeight)
		) {
			return;
		}

		const scrollY = window.scrollY;
		const direction = scrollY > lastScrollY.current ? 'down' : 'up';

		if (
			direction !== lastDirection.current &&
			(scrollY - lastScrollY.current > updateThreshold || scrollY - lastScrollY.current < -updateThreshold)
		) {
			lastDirection.current = direction;
			setScrollDirection(direction);
		}

		lastScrollY.current = scrollY > 0 ? scrollY : 0;
	};

	useEffect(() => {
		const index = onScroll(updateScrollDirection);

		return () => unBind(index);
	}, []);

	return scrollDirection;
};

export default useScrollDirection;
